import React from 'react';
import { Table } from 'antd';
import ReducedData from '../reducedData.json';
import dict from '../dictionary';
import trans from '../translations.json';

class StackedTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    data: undefined,
  };

  render() {
    //copy data coming in from props to a new object, remove some items that are too old, and build the new data for table
    const cData = Object.values(ReducedData.dataAges);
    var data = cData
      // .filter((item) => {
      //   if (item[dict.Age_Group] === "Unknown") {
      //     unknown =
      //       unknown +
      //       item[dict.resolved] +
      //       item[dict.NotResolved] +
      //       item[dict.deaths];
      //     return false;
      //   } else {
      //     return true;
      //   }
      // })
      .map((item, z) => {
        //console.log('item', item)
        switch (item[dict.Age_Group]) {
          case '<20':
            item[dict.Age_Group] =
              trans.casesByAge.under20[this.props.lang];
            break;
          case '20s':
            item[dict.Age_Group] = '20-29';
            break;
          case '30s':
            item[dict.Age_Group] = '30-39';
            break;
          case '40s':
            item[dict.Age_Group] = '40-49';
            break;
          case '50s':
            item[dict.Age_Group] = '50-59';
            break;
          case '60s':
            item[dict.Age_Group] = '60-69';
            break;
          case '70s':
            item[dict.Age_Group] = '70-79';
            break;
          case '80s':
            item[dict.Age_Group] = '80-89';
            break;
          case '90s':
            item[dict.Age_Group] = '90-99';
            break;
          case 'Unknown':
            item[dict.Age_Group] =
              trans.casesByAge.unk[this.props.lang];
            break;
          default:
            break;
        }
        return {
          ...item,
          index: z,
          total: (
            item[dict.resolved] +
            item[dict.NotResolved] +
            item[dict.deaths]
          ).toLocaleString(),
        };
      });

    const columns = [
      {
        title: trans.casesByAge.group[this.props.lang],
        dataIndex: dict.Age_Group,
        key: dict.Age_Group,
      },
      {
        title: trans.reg.total[this.props.lang],
        dataIndex: 'total',
        key: 'total',
      },
      {
        title: trans.casesByAge.active[this.props.lang],
        dataIndex: dict.NotResolved,
        key: dict.NotResolved,
      },
      {
        title: trans.casesByAge.resolved[this.props.lang],
        dataIndex: dict.resolved,
        key: dict.resolved,
      },

      {
        title: trans.casesByAge.fatal[this.props.lang],
        dataIndex: dict.deaths,
        key: dict.deaths,
      },
    ];
    return (
      <React.Fragment>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          scroll={{ x: 300 }}
        />
        {/* <p>
          {trans.casesByAge.noteA[this.props.lang]} {unknown}
          {trans.casesByAge.noteB[this.props.lang]}
        </p> */}
      </React.Fragment>
    );
  }
}

export default StackedTable;
